/** Elite Drive Solutions — premium design tokens */
export const EDS = {
  accent: "#0F172A",
  accentHover: "#334155",
  link: "#0369A1",
  linkHover: "#0284C7",
  ink: "#0F172A",
  inkSoft: "#334155",
  muted: "#64748B",
  subtle: "#94A3B8",
  line: "rgba(15, 23, 42, 0.06)",
  lineMedium: "rgba(15, 23, 42, 0.1)",
  canvas: "#FAFBFC",
  surface: "#FFFFFF",
  imageBg: "#F3F4F6",
  dark: "#0F172A",
  radius: 12,
  radiusLg: 20,
  shadowSoft: "0 1px 3px rgba(15, 23, 42, 0.04)",
  headerHeight: 64,
  fontDisplay:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
};

export const edsCssVars = {
  "--storefront-accent": EDS.ink,
  "--storefront-ink": EDS.ink,
  "--storefront-muted": EDS.muted,
  "--storefront-line": EDS.lineMedium,
  "--storefront-canvas": EDS.canvas,
};

export const resetButton = {
  margin: 0,
  border: 0,
  padding: 0,
  background: "none",
  font: "inherit",
  color: "inherit",
  cursor: "pointer",
  appearance: "none",
  WebkitAppearance: "none",
  textAlign: "inherit",
};

export const btnPrimary = {
  ...resetButton,
  bgcolor: EDS.ink,
  color: "#fff",
  fontWeight: 500,
  fontSize: "0.875rem",
  letterSpacing: "-0.01em",
  px: 2.25,
  py: 1.1,
  borderRadius: "999px",
  transition: "opacity 180ms ease",
  "&:hover": { opacity: 0.88 },
};

export const btnGhost = {
  ...resetButton,
  color: EDS.ink,
  fontWeight: 500,
  fontSize: "0.875rem",
  letterSpacing: "-0.01em",
  px: 2.25,
  py: 1.1,
  borderRadius: "999px",
  transition: "opacity 180ms ease",
  "&:hover": { opacity: 0.65 },
};

export const btnGhostLight = {
  ...resetButton,
  color: "rgba(255,255,255,0.88)",
  fontWeight: 500,
  fontSize: "0.875rem",
  letterSpacing: "-0.01em",
  px: 2.25,
  py: 1.1,
  borderRadius: "999px",
  transition: "opacity 180ms ease",
  "&:hover": { opacity: 0.72 },
};

export function priceText(value, currency = "USD") {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return "Request quote";
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
    }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}

export function resolvePrice(product) {
  const unitPrice = Number(product?.unitPrice);
  if (Number.isFinite(unitPrice) && unitPrice > 0) return product.unitPrice;
  const levels =
    product?.priceLevels && typeof product.priceLevels === "object"
      ? product.priceLevels
      : {};
  return levels.retail ?? levels.Retail ?? levels.RETAIL ?? product?.unitPrice;
}

export function normalizeTransmissions(raw) {
  const rows = raw?.data || raw || [];
  return (Array.isArray(rows) ? rows : [])
    .map((row) => row?.attributes?.name || row?.name || row?.label || "")
    .map((value) => String(value || "").trim())
    .filter(Boolean);
}
